import { vrfAbi } from '@/abi'
import { TRANSACTION_STATUS } from '@/constants/transactionStatus'
import { useContractAddresses, useTransactionModal } from '@/hooks'
import { useEffect } from 'react'
import {
  useAccount,
  useWaitForTransactionReceipt,
  useWriteContract,
} from 'wagmi'

export const useCreateSubscription = ({ refetchSubs }) => {
  const { address } = useAccount()
  const contracts = useContractAddresses()
  const { openModal } = useTransactionModal()

  const createSubscriptionInput = {
    account: address,
    abi: vrfAbi,
    address: contracts.vrf,
    functionName: 'createSubscription',
  }

  const {
    data: hash,
    isPending,
    isError: isWriteError,
    writeContractAsync,
  } = useWriteContract()

  useEffect(() => {
    if (isWriteError) {
      openModal(TRANSACTION_STATUS.IS_ERROR)
    }
  }, [isWriteError, openModal])

  const submit = () => {
    openModal(TRANSACTION_STATUS.IS_PENDING)
    return writeContractAsync(createSubscriptionInput)
  }

  const {
    data: result,
    isLoading: isConfirming,
    isError,
    isSuccess,
  } = useWaitForTransactionReceipt({ hash })

  useEffect(() => {
    if (isConfirming) {
      openModal(TRANSACTION_STATUS.IS_CONFIRMING)
    }
  }, [isConfirming, openModal])

  useEffect(() => {
    if (isSuccess) {
      openModal(TRANSACTION_STATUS.IS_SUCCESS)
      refetchSubs()
    }
  }, [isSuccess, openModal, refetchSubs])

  useEffect(() => {
    if (isError) {
      openModal(TRANSACTION_STATUS.IS_ERROR)
    }
  }, [isError, openModal])

  return {
    submit,
    result,
    isLoading: isPending || isConfirming,
  }
}
